import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userName: null,
  roomId: null,
  channelType: null,
};

const channelSlice = createSlice({
  name: 'channel',
  initialState,
  reducers: {
    setChannel: (state, action) => {
      state.userName = action.payload.userName;
      state.roomId = action.payload.roomId;
      state.channelType = action.payload.channelType;
    },
    clearChannel: (state) => {
      state.roomId = null;
      state.channelType = null;
      state.userName = null;
    },
  },
});

export const { setChannel, clearChannel } = channelSlice.actions;

export default channelSlice.reducer;
